import { Fragment, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { data$, getState } from '../../services/switcherServices';
import SpkTooltips from '../../@spk-reusable-components/reusable-uielements/spk-tooltips';
import type { Menuitemtype } from './nav';



const Menuloop = ({ MenuItems, level, handleToMenu, HoverToggleInnerMenuFn }: any) => {
  const location = useLocation();
  const scopedPath = (path?: string) => {
    const schedulingPrefixes = ['/scheduling/', '/schedule-settings/', '/scheduler-review/'];
    const isSchedulingPath = (value: string) => schedulingPrefixes.some((prefix) => value.startsWith(prefix));

    if (!path || !isSchedulingPath(path) || !isSchedulingPath(location.pathname)) {
      return path;
    }

    const [pathname, query = ''] = path.split('?');
    const currentParams = new URLSearchParams(location.search);
    const nextParams = new URLSearchParams(query);

    ['company', 'group'].forEach((key) => {
      const value = currentParams.get(key);
      if (value && !nextParams.has(key)) nextParams.set(key, value);
    });

    const nextQuery = nextParams.toString();
    return nextQuery ? `${pathname}?${nextQuery}` : pathname;
  };
  const handleClick = (event: MouseEvent) => {
    event.preventDefault(); // Prevents the default anchor behavior navigation;
  };

  let [variable, setVariable] = useState(getState());
  useEffect(() => {
    const subscription = data$.subscribe((e) => {
      // No need to manually update component state, the UI will re-render automatically
      setVariable(e);
    });
    console.log
    return () => subscription.unsubscribe(); // Clean up the subscription
  }, []);

  const local_varaiable = variable;
  return (
    <Fragment>
      <Link to={scopedPath(MenuItems.path) ?? "#!"} className={`side-menu__item ${MenuItems?.selected ? "active" : ""}`}
        onClick={(event) => { if (!MenuItems.path) { event.preventDefault(); } handleToMenu(event, MenuItems, undefined, true); }} onMouseEnter={(event) => HoverToggleInnerMenuFn(event, MenuItems)} >
        <i className="ri-arrow-right-s-line side-menu__angle"></i>
        <span className={`${local_varaiable?.dataVerticalStyle == 'doublemenu' ? '' : 'd-none'}`}>
          <SpkTooltips placement="right" title={MenuItems.title}>
            <div>{MenuItems.icon}</div>
          </SpkTooltips>
        </span>
        {local_varaiable?.dataVerticalStyle != "doublemenu" ? MenuItems.icon : ""}
        <span className={`${level == 1 ? "side-menu__label" : ""}`}> {MenuItems.title} {MenuItems.badgetxt ? (<span className={MenuItems.class}> {MenuItems.badgetxt} </span>
        ) : (
          ""
        )}
        </span>
      </Link>
      <ul className={`slide-menu child${level}  
      ${MenuItems.active && level == 1 && local_varaiable?.dataVerticalStyle === "doublemenu" ? 'double-menu-active' : ''} 
      ${MenuItems?.dirchange ? "force-left" : ""} `} style={MenuItems?.active ? { display: "block" } : { display: "none" }}
      >
        {level <= 1 ? <li className="slide side-menu__label1">
          <Link to="#!">{MenuItems.title}  </Link>
        </li> : ""}
        {MenuItems?.children?.map((firstlevel: Menuitemtype, index: number) =>
          <li className={`${firstlevel?.menutitle ? 'slide__category' : ''} ${firstlevel?.type == 'empty' ? 'slide' : ''} ${firstlevel?.type == 'link' ? 'slide' : ''} ${firstlevel?.type == 'sub' ? 'slide has-sub' : ''} ${firstlevel.active ? 'open' : ''} ${firstlevel.selected ? 'active' : ''}`}
            key={index}
          >
            {firstlevel?.type === "link" ?
              <Link to={scopedPath(firstlevel.path) ?? '#!'} className={`side-menu__item ${firstlevel?.selected ? 'active' : ''}`}>{firstlevel.icon}
                <span className=""> {firstlevel.title} {firstlevel.badgetxt ? (<span className={firstlevel.class}> {firstlevel.badgetxt}</span>
                ) : (
                  ""
                )}
                </span>
              </Link>
              : ""}
            {firstlevel?.type === "empty" ?
              <Link to="#!" className={`side-menu__item`} onClick={handleClick}>
                {firstlevel.title}
                {firstlevel.icon}
              </Link>
              : ""}
            {firstlevel?.type === "sub" ?
              <Menuloop MenuItems={firstlevel} handleToMenu={handleToMenu} level={level + 1} HoverToggleInnerMenuFn={HoverToggleInnerMenuFn} /> : ''}
          </li>
        )}

      </ul>
    </Fragment>
  );
};

export default Menuloop;
